<template>
  <header>
    <img
      src="@/assets/img/rickmortylogo.png"
      alt="rick and morty banner image"
      width="1000"
    />
  </header>
</template>

<style lang="scss" scoped>
header {
  padding-top: 2rem;

  > img {
    max-width: 100%;
  }
}
</style>
